import React, { type ReactNode } from "react";
import { Link } from "ui/link";
import Image from "next/image";
import { type Item } from "components/footer/data";
import { Box, Flex, Text } from "@chakra-ui/react";

type NavItemProps = {
  children: ReactNode;
} & Pick<Item, "url" | "leftIcon" | "rightIcon" | "onClick">;

export function NavItem({ url, children, leftIcon, rightIcon, onClick }: NavItemProps) {
  return (
    <Link variant="footer" href={url} onClick={onClick}>
      {/* Keep text and left icon wrapped in `span` so that opacity styles in link.ts are scoped to text only and not the right icon */}
      <Text as="span" display="inline-flex" alignItems="center">
        {leftIcon && <Flex as={leftIcon} align="center" justify="center" boxSize="icon.sm" mr="tiny" />}
        {children}
      </Text>
      {rightIcon && (
        <Box boxSize="24px" pos="relative">
          <Image fill sizes="100%" src={rightIcon.src} alt={rightIcon.alt} />
        </Box>
      )}
    </Link>
  );
}
